import { render, staticRenderFns } from "./TipoDeContrato.vue?vue&type=template&id=1c9cc527&"
import script from "./TipoDeContrato.vue?vue&type=script&lang=js&"
export * from "./TipoDeContrato.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports